import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from './config';
import CreaEvento from './CreaEvento';
import ModificaEvento from './ModificaEvento';

const EventList = ({ idAzienda }) => {

  const [eventi, setUsers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedEvento, setSelectedEvento] = useState(null); 
  const [selectedAziendaId, setSelectedAziendaId] = useState(null);
  

  

  // Fetch azienda una volta quando il componente viene montato
  useEffect(() => {
    if(idAzienda)
    {
      setSelectedAziendaId(idAzienda);

    }
    else{
          fetchAzienda();
    }
  }, []);

  // Fetch users quando selectedAziendaId cambia o currentPage cambia
  useEffect(() => {
    
    if (selectedAziendaId) {
      fetchUsers(currentPage);
    }
  }, [selectedAziendaId, currentPage]);

  const fetchAzienda = async () => {
    
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('accessToken'));
    headers.append('Content-Type', 'application/json');
  
    try {

      let url = `${BASE_URL}/v1/user/aziende`;

      const response = await fetch(url, {
        headers: headers
      });
      const data = await response.json();
  
      if (Array.isArray(data) && data.length > 0) {
        const firstAzienda = data[0];
        const selectedAziendaType = Array.isArray(firstAzienda.tipologie)
          ? firstAzienda.tipologie.map(tipo => tipo.code).join(',')
          : ''; // Usa una stringa vuota se `tipologie` non è un array
  
        setSelectedAziendaId(firstAzienda.idAzienda);
     
      } else {
        console.error('Nessuna azienda trovata o i dati non sono un array:', data);
      }
    } catch (error) {
      console.error('Errore durante la chiamata API:', error);
    }
  };
  
  
  const fetchUsers = async (selectedPage) => {
    
    if (!selectedAziendaId) {
      return; // Non fare nulla se selectedAziendaId non è ancora stato impostato
    }
  

    try {
      const response = await axios.get(`${BASE_URL}/azienda/eventi/` + selectedAziendaId, {
        
        params: {
          page: selectedPage,
          size: 10, // Numero di utenti per pagina
          sort: 'idEvento,desc'
        },
       
      });
      
      
      setUsers(response.data.eventi);
      setPageCount(response.data.paginaEventi);
    } catch (error) {
      console.error('Errore durante il recupero degli utenti:', error);
    }
  };

  const handlePageClick = (data) => {

    setCurrentPage(data.selected);
  };

  const handleSelectEvento = (evento) => {

    setSelectedEvento(evento); // 👈 Imposta l'evento selezionato


  };

  const handleBackToList = () => {
    
    setSelectedEvento(null); // 👈 Torna alla lista
    

  };

  if (selectedEvento) {
    // Se è selezionato un evento, mostra il componente di modifica
    return <ModificaEvento idEvento={selectedEvento.id} evento={selectedEvento} onBack={handleBackToList} />;
    


  }

  const handleToggleActive = async (userId, isActive) => {
    try {

      
    var token =  sessionStorage.getItem('accessToken');
    
  

    const headers = {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    };
  
  
    await axios.put(`${BASE_URL}/azienda/eventi/${userId}/stato`, {}, { headers: headers });
  
      fetchUsers(currentPage); // Ricarica gli utenti
      toast.success('evento ' +  !isActive?'attivato':'disattivato' + ' con successo');
    } catch (error) {
   
   toast.error(error.response.data);
   
    }
  };

  const handleDeleteUser = async (userId) => {
    const confirmDelete = window.confirm('Sei sicuro di voler cancellare questo evento?');
    if (confirmDelete) {
      try {

  
      
        var token =  sessionStorage.getItem('accessToken');
    
  

        const headers = {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        };
  
        
      
        await axios.delete(`${BASE_URL}/azienda/eventi/${userId}`, { headers: headers });
        setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
        toast.success('evento cancellato con successo');
      } catch (error) {
    
        toast.error(error.response.data);
      }
    }
  };
  

  return (
    <div>
      <h2>Lista offerte</h2>
      <table>
        <thead>
          <tr>
            <th>Titolo</th>
            <th>tipologia</th>
            <th>Data</th>
            <th>Prezzo</th>
            <th>Attivo</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {eventi.map((evento) => (
            <tr key={evento.id}>
              <td>{evento.titolo}</td>
              <td>{evento.categorie && evento.categorie.length > 0 ? evento.categorie[0].nome : 'N/A'}</td>
              <td>{evento.dataInizio} - {evento.dataFine}</td>
              
              <td>{evento.prezzo}</td>
              <td>
                <input
                  type="checkbox"
                  checked={evento.active}
                  onChange={() => handleToggleActive(evento.id, evento.active)}
                />
              </td>
              <td>
                <button onClick={() => handleSelectEvento(evento)}>Dettaglio</button> <span></span>
                <button onClick={() => handleDeleteUser(evento.id)}>Cancella</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={'Precedente'}
        nextLabel={'Successivo'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />
      <ToastContainer />
    </div>
    
  );
};

export default EventList;
